/**
 * Feature flags for enabling/disabling features in development
 * Set to true to enable a feature, false to disable it
 */

export const FEATURE_FLAGS = {
  // Animation tool for creating card game state animations/GIFs
  // Set to true to enable, false to disable
  ANIMATIONS_TOOL: true,
};

/**
 * Check if a feature is enabled
 * @param {string} flagName - The feature flag name
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (flagName) => {
  return FEATURE_FLAGS[flagName] ?? false;
};
